import { ComponentType, lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

function PageLoader() {
  return (
    <div className="flex items-center justify-center w-full h-64">
      <Loader2 className="w-10 h-10 text-orange-500 animate-spin" />
    </div>
  );
}

export function lazyRoute(
  importFn: () => Promise<{ default: ComponentType }>
) {
  const Comp = lazy(importFn);
  return (
    <Suspense fallback={<PageLoader />}>
      <Comp />
    </Suspense>
  );
}
